import React from 'react';
import Icon from './Icon';
var cache = new Set();
export default function createFromIconfontCN(scriptUrl) {
  if (typeof document !== 'undefined' && typeof window !== 'undefined' && typeof document.createElement === 'function' && typeof scriptUrl === 'string' && scriptUrl.length && !cache.has(scriptUrl)) {
    var script = document.createElement('script');
    script.setAttribute('src', scriptUrl);
    script.setAttribute('data-namespace', scriptUrl);
    cache.add(scriptUrl);
    document.body.appendChild(script);
  }

  var Iconfont = function Iconfont(props) {
    Iconfont.displayName = 'Iconfont';
    var name = props.name;
    var content;

    if (name) {
      content = /*#__PURE__*/React.createElement("svg", {
        width: "1em",
        height: "1em",
        fill: "currentColor"
      }, /*#__PURE__*/React.createElement("use", {
        xlinkHref: "#".concat(name)
      }));
    }

    return /*#__PURE__*/React.createElement(Icon, props, content);
  };

  return Iconfont;
}